<template>
  <div class="main-container-view-proposals ">

    <b-link @click="redirectLastRoute($router)" class="text-blue d-block mb-1">
      <span>
        {{ $t('tracking.goBack') }}
      </span>
    </b-link>
    <talent-details-preview
      v-if="can_edit_talent"
      class="mb-1"
      :details="details"
      @edit_proposal="editProposal"
    />
    <header-images-preview 
      class="mb-1"
      :data_header="details || {images: []}"
      :loading="!loaded"
      :is_avaible_to_editing="true"
      @edit_proposal="editProposal"
      :key="update_header_images_preview"
      v-if="details && details.details_proposal_uuid"
    />
    <b-row class="m-0">
      <b-col :class="`col-12 p-0 w-100`">
        <title-and-description-preview
          :data_header="details ? details : {}"
          :is_avaible_to_editing="true"
          :loading="!details"
          @edit_proposal="editProposal"
          class="mb-1"
        />
        <donut-metrics 
          v-if="!is_in_sidebar && total_followers > 0"
          :class="`col-12 p-0`" 
          :networks="details ? details.followers_count : {}" 
          :followers_by_username="details ? details.followers_by_username : []"
          :loading="!loaded"
        ></donut-metrics>

        <b-button v-if="!is_brand && !vanity_name" class="add-deal-action my-2" variant="add-deal-action" @click="modal_edit_vanity = true"> {{ $t('creator.EditVanity') }} </b-button>
        <!-- Public deals -->
        <deals-list-section
          :loading="!loaded"
          :proposals="proposals"
          :selected_deal_radio.sync="selected_deal_radio"
          :is_in_sidebar="is_in_sidebar"
          :is_avaible_to_editing="true"
          :current_page="current_page"
          :total_rows="total_rows"
          :per_page="per_page"
          :is_brandme_talent="details ? details.is_brandme_talent : false"
          @deal_selected="dealSelected"
          @edit_deal="editProposal"
          @update_current_page="handlePageChange"
        />
        
      </b-col>
    </b-row>

    <sidebar-edit-proposal
      v-if="open_sidebar_edit"
      class="open-sidebar-edit-proposal" 
      :open_sidebar_edit="open_sidebar_edit"
      :details="details"
      :key="update_sidebar_edit"
      :section_dad="section_to_edit"
      :data_for_sidebar="data_for_sidebar"
      :chat_uuid="chat_uuid"
      :edit_by_agency="true"
      :owner_is_brandme_talent="can_use_price_range"
      @update_proposal="updateProposal"
      @update_deals="updateDeals"
      @update_private_deal="updatePrivateDeals"
      @close_siderbar="closeSidebarEdit"
      :hide_sidebar="false"
    ></sidebar-edit-proposal>
  </div>
</template>
      
<script>
import { BCol, BLink, BRow, BButton } from "bootstrap-vue";
import { proposalsDealsRepository } from "@/infrastructure/proposals/proposals.repository";
import { isDiscountValid, applyBalanceDiscount, validateOnlyNumbers, getNetworksUsedInProposals } from '@/domain/proposal/proposal.domain';
import { isBrand } from '@/domain/user/access.domain';
import { makeLoadProposalsDealsUseCase, makeLoadProposalsPageUseCase, makeCreateChatBrandmeTalentUseCase, makeExecuteProposalBuyFlowUseCase, makeLoadPrivateDeals } from "@/application/proposals/loadProposalsDeals.usecase";
import { redirectLastRoute, showToast } from '@/libs/utils/others';
import { getUserData, hasPermission } from '@/libs/utils/user';
import TitleAndDescriptionPreview from "@/views/components/proposals/components/TitleAndDescriptionPreview.vue";
import HeaderImagesPreview from "@/views/components/proposals/components/HeaderImagesPreview.vue";
import DonutMetrics from "./components/DonutMetrics.vue";
import DealsListSection from "@/views/pages/proposals/stepper/viewProposals/components/DealsListSection.vue";
import TalentDetailsPreview from "@/views/components/proposals/components/TalentDetailsPreview.vue";

export default {
  name: "editProposalAgency",
  components: {
    BCol,
    BLink,
    BRow,
    BButton,
    HeaderImagesPreview,
    DonutMetrics,
    TitleAndDescriptionPreview,
    DealsListSection,
    TalentDetailsPreview,
    SidebarEditProposal: () => import('@/views/pages/proposals/stepper/sidebarEditProposal.vue'),
  },
  data() {
    return {
      proposals: [],
      details: null,
      current_page: 1,
      per_page: 5,
      current_page_private_deals: 1,
      per_page_private_deals: 5,
      selected_deal_radio: { price : 0, licensing: null },
      string_key: null,
      buy_loader: false,
      loaded: false,
      proposal_for_checkout: null,
      apply_balance: false,
      balance_discount: 0,
      total_discounted: 0,
      view_change_balance: false,
      checked_options: [], // ? 
      modal_buy: false,
      change_modal: 0,
      is_your_proposal: false,
      update_modal_login: false,
      open_modal_login: false,  
      total_rows: 0,
      total_rows_private_deals: 0,
      private_deals: [],
      data_for_sidebar: null,
      section_to_edit: null,
      open_sidebar_edit: false,
      update_sidebar_edit: 0,
      update_header_images_preview: 0.1,
      total_followers: 0,
      modal_edit_vanity: false,
    };
  },  
  computed: {
    user_data() {
      return getUserData();
    },
    can_edit_talent() {
      return !!(this.details && this.details.external_agency) && hasPermission('user_agency');
    },
    can_use_price_range() {
      // Las agencias siempre pueden elegir entre precio o rango; si no, depende del dueño del deal
      return hasPermission('user_agency') || !!(this.details && this.details.is_brandme_talent);
    },
    vanity_name() {
      return this.$route.params.vanity_name || this.vanity_name_dad;
    },
    is_brand() {
      return isBrand(this.user_data);
    },
    is_authenticated() {
      return this.user_data !== null;
    },
    get_balance() {
      if (this.is_authenticated) return this.user_data.balance;
      return 0
    },
  },
  props: {
    force_show_buy_button: {
      type: Boolean,
      default: false,
    },
    is_in_sidebar: {
      type: Boolean,
      default: false,
    },
    vanity_name_dad: {
      type: String,
      default: null,
    },
    is_adding_deal: {
      type: Boolean,
      default: false,
    },
    chat_uuid: {
      type: String,
      default: null,
    }
  },
  async created() {
    await this.loadInitialData(this.current_page);
  },
  methods: {
    closeSidebarEdit() {
      this.open_sidebar_edit = false;
      this.$emit("close_siderbar");
    },
    redirectLastRoute,
    updatePrivateDeals(response, action) {
      if (action === 'delete') {
        this.private_deals = this.private_deals.filter(d => d.uuid !== response);
      } else if (action === 'create') {
        this.private_deals.push(response);
        this.closeSidebarEdit();
      } else if (action === 'update') {
        const index = this.private_deals.findIndex(d => d.uuid === response.uuid);
        if (index !== -1) {
          this.$set(this.private_deals, index, response);
        }
      }
      this.$emit('update_deals');
    },
    getNetworksUsedInProposals,
    deleteDiscount() {
      this.apply_balance = false;
      this.balance_discount = 0;
    },
    updateProposal(response, key) {
      if (key) {
        this.details = { ...this.details, [key]: response };
      }

      if (key === 'images') this.update_header_images_preview += 0.1;
    
      if (!key) {
        this.details = response;
      }
    },
    updateDeals(response, action) {
      if (action === 'delete') {
        this.proposals = this.proposals.filter(deal => deal.uuid !== response);
      } else if (action === 'update') {
        const index = this.proposals.findIndex(deal => deal.uuid === response.uuid);
        if (index !== -1) {
          this.$set(this.proposals, index, response);
        }
      } else if (action === 'create') {
        this.proposals.push(response);
      }
      this.$emit('update_deals');
    },
    modalBuy() {
      this.modal_buy = true,
      this.change_modal += 1
    },
    applyDiscount() {
      if (isDiscountValid(this.balance_discount, this.get_balance, this.checked_options, this.selected_deal_radio)) {
        this.apply_balance = true;
        this.total_discounted = applyBalanceDiscount(this.balance_discount, this.checked_options, this.selected_deal_radio);
        this.view_change_balance = false
      }
    },
    editProposal(section, data) {
      this.section_to_edit = section;
      this.data_for_sidebar = data;
      this.open_sidebar_edit = true; this.update_sidebar_edit += 1;
    },
    onlyNumbers(event) {
      validateOnlyNumbers(event);
    },
    async handlePageChange(page, type = 'proposals') {
      const is_private = type === 'private_deals';
      const current = is_private ? 'current_page_private_deals' : 'current_page';
      if (page === this[current]) return;
      this[current] = page;
      await this.loadPage(type, page);
    },
    async loadInitialData(page) {
      const load_data = makeLoadProposalsDealsUseCase({ proposalsDealsRepository }, this.vanity_name, page, this.per_page, this.chat_uuid, this.current_page_private_deals, this.per_page_private_deals);
      
      try {
        const { proposals, details, proposal_for_checkout, string_key, private_deals } = await load_data();
        this.details = { ...details, is_in_sidebar: false, uploaded_images: false, loaded_ia_title: false };
        this.total_followers = details.total_followers || 0;
        this.proposal_for_checkout = proposal_for_checkout;
        this.assignProposals(proposals, string_key);
        this.assignPrivateDeals(private_deals);
      } catch (error) {
        this.details = {};
        this.proposals = [];
        this.total_rows = this.total_rows_private_deals = 0;
        showToast(this, 'danger', 'AlertCircleIcon', error.message, '', { translate_title: false, translate_text: false, position: 'top-right' });
      }
    },
    async loadPage(type, page) {
      const is_private = type === 'private_deals';
      const load_data = is_private ? makeLoadPrivateDeals({ proposalsDealsRepository }, this.chat_uuid, page, this.per_page_private_deals) : makeLoadProposalsPageUseCase({ proposalsDealsRepository }, this.vanity_name, page, this.per_page);

      try {
        const result = await load_data();
        is_private ? this.assignPrivateDeals(result.proposals) : this.assignProposals(result.proposals, result.string_key);
      } catch (error) {
        if (is_private) { 
          this.private_deals = []; 
          this.total_rows_private_deals = 0; 
        } else { 
          this.proposals = []; 
          this.total_rows = 0; 
        }
        showToast(this, 'danger', 'AlertCircleIcon', error.message, '', { translate_title: false, translate_text: false, position: 'top-right' });
      }
    },
    assignProposals(proposals, string_key = null) {
      this.proposals = proposals?.results ?? [];
      this.total_rows = proposals?.count ?? 0;
      this.string_key = string_key;
      this.selected_deal_radio = this.proposals.length > 0 ? this.proposals[0] : { price: 0, licensing: null };
      this.loaded = true;
    },
    assignPrivateDeals(private_deals) {
      this.total_rows_private_deals = private_deals?.count ?? 0;
      this.private_deals = private_deals?.results ?? [];
    },
    dealSelected(deal) {
      this.selected_deal_radio = deal;

      // getTotal(this.checked_options, this.deal_selected);
      // this.applyDiscount();
    },
    redirectVanity() {
      if (this.vanity_name) {
        this.$router.push({ name: 'user_profile', params: { user: this.vanity_name } });
      }
    },
    async messageAction() {
      if (!this.is_authenticated) {
        this.openModalLogin();
        return;
      }
      try {
        const createChat = this.buildCreateChatUsecase();
        const response = await createChat();
        this.navigateToChat(response.uuid);
      } catch (error) {
        showToast(this, 'danger', 'AlertCircleIcon', error.message, '', { translate_title: false, translate_text: false, position: 'top-right' });
      }
    },
    openModalLogin() {
      this.open_modal_login = true;
      this.update_modal_login = !this.update_modal_login;
    },
    buildCreateChatUsecase() {
      return makeCreateChatBrandmeTalentUseCase({ proposalsDealsRepository }, this.details.id);
    },
    navigateToChat(chatUuid) {
      if (this.$route.name === 'chat-proposal' && this.$route.params.chat_uuid === chatUuid) {
        showToast(this, 'success', 'BellIcon', 'creator.YouFind', 'creator.chatActive');
        return;
      }
      this.$router.push({ name: 'chat-proposal', params: { chat_uuid: chatUuid } }).catch(() => {});
    },
    async buyAction() {
      if (!this.is_authenticated) {
        this.openModalLogin();
        return;
      }

      this.buy_loader = true;
      try {
        const executeBuyFlow = makeExecuteProposalBuyFlowUseCase(
          { proposalsDealsRepository },
          {
            deal_selected: this.selected_deal_radio,
            is_brandme_talent: this.selected_deal_radio.is_brandme_talent,
            apply_balance: this.apply_balance,
            balance_discount: this.balance_discount,
            user_id: this.details.id,
          },
        );

        const result = await executeBuyFlow();
        if (result.type === 'chat') {
          this.navigateToChat(result.chat_uuid);
        } else {
          window.location.href = result.url;
        }
      } catch (error) {
        showToast(this, 'danger', 'AlertCircleIcon', error.message, '', { translate_title: false, translate_text: false, position: 'top-right' });
      } finally {
        this.buy_loader = false;
      }
    },
  },
  watch: {
    is_adding_deal(newValue) {
      if (newValue) {
        this.open_sidebar_edit = true;
        this.section_to_edit = 'deals';
        this.data_for_sidebar = { };
        this.update_sidebar_edit += 1;
        this.$emit('is_adding_deal', false);
      }
    },
  }
};
</script>
<style>
.open-sidebar-edit-proposal > .b-sidebar-right {
    animation: sidebar-edit-proposal 500ms;
  }
  @keyframes sidebar-edit-proposal {
  0% {
    transform: translateX(500px)
  }
  100% {
    transform: translateX(0px)
  }
}
</style>
<style lang="scss" scoped>

.main-container-view-proposals {
  margin: 0 auto;
  max-width: 1430px;
}
.container-nav-fixed {
  width: 100%;
  height: 80px;
  position: sticky;
  background-color: white;
  left: 0;
  bottom: 0;
  display: flex;
  padding: 0 0.8em;
  justify-content: space-between;
  align-items: center;
  box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
  z-index: 10;

  .btn-bag-shopping {
    border-color: #ced4da;
    font-size: 0.875rem;
    margin: 12px 0px 12px 0px;
    height: auto;
    padding: 10px;
  }
  .btn-bag-shopping:hover {
    background-color: rgba(0, 0, 0, 0.025);
  }
  .text-order {
    color:#495057;
    font-size: .745rem !important;
    margin-block: 4px;
  }

  .btn-buy {
    height: 45px !important;
    padding: 4px 1em !important;

    @media(max-width: 700px) {
      width: auto !important;
      padding: 4px 1em !important;
    }
  }

  @media(max-width: 500px) {
    padding: 0 1em;
  }
}
.add-deal-action {
  width: 100%;
  color: #3b8DA8;
  background-color: #E6f2f6;
  border: 1px solid #3b8DA8;
  padding: 2em;
  border-radius: 1em;
}
.add-deal-action:hover {
  color: #ffff;
  transition: all 500ms;
  background-color: #3b8DA8;
}
</style>